import { motion } from "framer-motion";
import { FileText } from "lucide-react";

export default function SecondaOpinione() {
  return (
    <section
      id="seconda-opinione"
      data-testid="seconda-opinione-section"
      className="py-24 md:py-32 bg-[#F9F8F6] border-y border-[#E5E1D8]"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <p className="eyebrow">Seconda opinione</p>
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-6 text-[#1A1D1A]"
          >
            Seconda opinione <span className="italic text-[#8A6D56]">ematologica</span>.
          </motion.h2>
          <p className="text-[#5C635E] leading-relaxed mt-8 max-w-[620px]">
            In presenza di una diagnosi complessa, di dubbi sulla terapia o prima di
            scelte cliniche importanti, un secondo parere specialistico consente di
            confrontare le opzioni e prendere decisioni informate.
          </p>
          <p className="text-[#5C635E] leading-relaxed mt-4 max-w-[620px]">
            Nella consulenza vengono rivalutati esami, referti istologici e radiologici,
            e viene redatta una relazione clinica strutturata da condividere con il medico
            curante.
          </p>

          <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 max-w-[620px]">
            {[
              "Rilettura completa della documentazione",
              "Confronto con linee guida internazionali",
              "Relazione clinica scritta",
              "Indicazioni operative per il curante",
            ].map((v) => (
              <li key={v} className="flex gap-3 text-[14px] text-[#1A1D1A]/90">
                <span className="mt-[7px] w-1.5 h-1.5 rounded-full bg-[#8A6D56] shrink-0" aria-hidden />
                <span>{v}</span>
              </li>
            ))}
          </ul>

          <div className="mt-12 flex flex-wrap gap-4">
            <a
              href="#prenota"
              data-testid="seconda-opinione-cta"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#8A6D56] text-white text-sm font-semibold hover:bg-[#735A47] transition-colors duration-200"
            >
              Richiedi una seconda opinione
              <span aria-hidden>→</span>
            </a>
            <a
              href="#contatti"
              data-testid="seconda-opinione-info"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-[#1A1D1A]/15 text-[#1A1D1A] text-sm font-semibold hover:bg-[#EFECE7] transition-colors duration-200"
            >
              Informazioni preliminari
            </a>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="bg-white border border-[#E5E1D8] rounded-2xl p-8 md:p-10">
            <div className="w-12 h-12 rounded-full bg-[#EFECE7] grid place-items-center border border-[#E5E1D8]">
              <FileText className="w-5 h-5 text-[#8A6D56]" strokeWidth={1.5} />
            </div>
            <p className="eyebrow mt-8">Documentazione utile</p>
            <p className="font-serif-display text-2xl leading-snug mt-3 text-[#1A1D1A]">
              Cosa portare in consulenza
            </p>
            <ul className="mt-6 space-y-4 text-[14px] text-[#1A1D1A]/85 border-t border-[#E5E1D8] pt-6">
              {[
                "Esami ematochimici recenti (ultimi 6 mesi)",
                "Referti di biopsia, istologia o citologia",
                "Referti radiologici (TC, RM, PET, ecografie)",
                "Lettera del medico curante o dello specialista di riferimento",
                "Elenco della terapia in corso",
              ].map((v) => (
                <li key={v} className="flex gap-3">
                  <span className="mt-[6px] w-1 h-1 rounded-full bg-[#8A6D56] shrink-0" aria-hidden />
                  <span>{v}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
